import React from 'react';
import '../../assets/stylesheets/Units/ValidatedInput.scss';

const ValidatedInput = ({
    className,
    wrapperClassName,
    valid,
    onChange,
    ...params
}) => {
    const classes = ['validatedInput'];
    if (className) classes.push(className);
    if (valid) classes.push('validatedInput--valid');
    else if(!!params.value && !valid && valid !== undefined) classes.push('validatedInput--inValid')

    const wrapperClasses = ['validatedInputWrapper'];
    if (wrapperClassName) wrapperClasses.push(wrapperClassName);
    if (valid) wrapperClasses.push('validatedInputWrapper--valid');
    else if(!!params.value && !valid && valid !== undefined) wrapperClasses.push('validatedInputWrapper--inValid')

    return (
        <div className={wrapperClasses.join(' ')}>
            <input className={classes.join(' ')} onChange={onChange} {...params} />
        </div>
    );
}

export default ValidatedInput;